import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { optimizationApi, type CapacityForecast } from '../../api/optimization';

export function CapacityPlanningPage() {
  const [forecasts, setForecasts] = useState<CapacityForecast[]>([]);
  useEffect(() => { void optimizationApi.capacity().then(setForecasts); }, []);
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Capacity Planning Dashboard</h1>
      <Link to="/optimization" className="mt-2 inline-block text-sm text-violet-700 hover:underline dark:text-violet-400">← Optimization Center</Link>
      <div className="mt-6 grid gap-4 sm:grid-cols-2">{forecasts.map((f) => (
        <div key={f.id} className="rounded-xl border p-4 dark:border-slate-700 dark:bg-slate-900">
          <p className="font-medium capitalize">{f.resource.replace(/_/g, ' ')}</p>
          <p className="text-sm text-slate-500">Current: {f.current_usage} {f.unit}</p>
          <p className="text-sm">30d: {f.forecast_30d} · 90d: {f.forecast_90d}</p>
          {f.recommendation && <p className="mt-2 text-xs text-violet-600 dark:text-violet-400">{f.recommendation}</p>}
        </div>
      ))}</div>
    </div>
  );
}
